export default IconHierarchy2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hierarchy-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 3h4v4h-4z" />
  <path d="M3 17h4v4h-4z" />
  <path d="M17 17h4v4h-4z" />
  <path d="M7 17l5 -4l5 4" />
  <path d="M12 7l0 6" />
</svg>`;